export default __webpack_public_path__ + "static/media/Stories.16b20e28.png";